import state from '@/taskpane/state/sidebar-state'
import MessageArgs from '../messages/message-args'
import office from '@/taskpane/officejs/office-wrapper'
import officeApiWrapper from '@/taskpane/common/office-api-wrapper'
import configuration from '@/taskpane/common/configuration'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'

interface EmailPostSentCallbackHandlerArgs extends MessageArgs {
  id: string
  threadId: string
  headerMessageId: string
  success: boolean
}

export default async function emailPostSentCallbackHandler(args: EmailPostSentCallbackHandlerArgs) {
  // On failure, leave the entry queued — the drainer's backoff will retry it. Nothing
  // to do here explicitly; markAttempted was already applied when the send went out.
  if (!args.success) {
    return
  }

  if (officeApiWrapper.isAvailable()) {
    await handleOffice(args)
  } else if (office.ews.isAvailable()) {
    await handleEws(args)
  }
}

async function handleOffice(args: EmailPostSentCallbackHandlerArgs) {
  const entry = state.sentItemsProcessor.findById(args.id)

  if (entry) {
    await officeApiWrapper.setMailCustomProperties(args.id, {
      [configuration.CI_HANDLED_PROPERTY_NAME]: 'true',
    })
    await state.sentItemsProcessor.ack(args.id)
  }

  if (args.threadId === state.currentItem.apiInfo.conversationId) {
    sendMessageToSidebar('ForceTrackingUpdate', args.threadId)
  }
}

async function handleEws(args: EmailPostSentCallbackHandlerArgs) {
  const entry = state.sentItemsProcessor.findById(args.id)

  if (entry?.changeKey) {
    await office.ews.markItemAsProcessed(entry.id, entry.changeKey)
    await state.sentItemsProcessor.ack(args.id)
  }
}
